export default __webpack_public_path__ + "static/media/Add notes-cuate 1.5cfba167.png";